<script setup>
// import i18n from "@/i18n"
import { defineProps, defineEmits, inject, 
    computed, 
    ref 

} from "vue";
import Swal from "sweetalert2";
import { useRoute } from "vue-router";
import copySvg from "@/assets/images/svg/copy.svg"
import customTableCom from "./customTable.vue";
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
const props = defineProps({
    customFieldsList: {
        type: Array,
        required: true,
        default: () => []
    },
})
const isCheckForm = inject('isCheckForm')
const route = useRoute()
const emits = defineEmits(["update:customFieldsList"])
// const { customFieldsList } = toRefs(props)
// const customFieldsList = ref([])
const customFieldsList = ref(computed(() => props.customFieldsList))
const currentTabLang = inject('currentTabLang') //切换语言
// watch(() => props.customFieldsList, (newVal) => {
//     customFieldsList.value = newVal;
// }, { deep: true });

//方法
const handler = (type, i = "", item) => {
    // console.log(i);
    switch (type) {
        case "copy": {
            let item1 = JSON.parse(JSON.stringify(item))
            // 修改id
            item1.id = item.id ? `${item.id}${customFieldsList.value.length + 1}` : `cusText${customFieldsList.value.length + 1}`
            item1.key = item.key ? `${item.key}${customFieldsList.value.length + 1}` : `cusText${customFieldsList.value.length + 1}`
            let new_customFieldsList = [
                ...customFieldsList.value.slice(0, i + 1),
                item1,
                ...customFieldsList.value.slice(i + 1),
            ];
            // console.log(new_customFieldsList);
            emits('update:customFieldsList', new_customFieldsList)
            break;
        }
        case "delete": {
            Swal.fire({
                title: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_title"): getLangValueByKey("base.delete_alert_title", 'en'),
                text: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_info"): getLangValueByKey("base.delete_alert_info", 'en'),
                icon: "warning",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
                cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
            }).then(async (result) => {
                if (result.isConfirmed) {
                    customFieldsList.value.splice(i, 1)
                    emits('update:customFieldsList', customFieldsList.value)
                }
            });

            break;
        }
        default:
            break;
    }
}
const addField = (index) => {
    customFieldsList.value[index].fieldsList.push({
        name: `${getLangValueByKey('product-template.template_text_field')}${customFieldsList.value[index].fieldsList.length + 1}`,
        name_en: `${getLangValueByKey('product-template.template_text_field', 'en')}${customFieldsList.value[index].fieldsList.length + 1}`,
        unit: "",
        key: `字段${customFieldsList.value[index].fieldsList.length + 1}`
    })
    emits('update:customFieldsList', customFieldsList.value)
}
const deleteField = (index, index_field) => {
    const { fieldsList } = customFieldsList.value[index]
    fieldsList.splice(index_field, 1)
    emits('update:customFieldsList', customFieldsList.value)
}
const editField = (index, index_field) => {
    const { fieldsList } = customFieldsList.value[index]
    const { name, name_en } = fieldsList[index_field]
    Swal.fire({
        title:currentTabLang.value ==1?  getLangValueByKey("product-template.enterFieldName"): getLangValueByKey("product-template.enterFieldName", 'en'),
        input: "text",
        inputValue: currentTabLang.value == 1 ? name : name_en,
        showCancelButton: true,
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
        showLoaderOnConfirm: true,
        confirmButtonColor: "#0AB39c",
        cancelButtonColor: "#f06548",
        inputValidator: (value) => {
            if (!value) {
                return currentTabLang.value == 1? getLangValueByKey("product-template.requeiredInfo"): getLangValueByKey("product-template.requeiredInfo", 'en')
            }
        },
        preConfirm: (value) => {
            if (value) {
                if (currentTabLang.value == 1) {
                    fieldsList[index_field].name = value
                } else {
                    fieldsList[index_field].name_en = value
                }

                emits('update:customFieldsList', customFieldsList.value)
            }

        },
        allowOutsideClick: false,
    }).then((text) => {
        console.log(text);
    });
}

const editFields = (i) => {
    //tab 字段名称修改
    const { name, name_en } = customFieldsList.value[i];
    Swal.fire({
        title:currentTabLang.value ==1?  getLangValueByKey("product-template.enterFieldName"): getLangValueByKey("product-template.enterFieldName", 'en'),
        input: "text",
        inputValue: currentTabLang.value == 1 ? name : name_en,
        showCancelButton: true,
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
        showLoaderOnConfirm: true,
        confirmButtonColor: "#0AB39c",
        cancelButtonColor: "#f06548",
        inputValidator: (value) => {
            if (!value) {
                return currentTabLang.value == 1? getLangValueByKey("product-template.requeiredInfo"): getLangValueByKey("product-template.requeiredInfo", 'en')
            }
        },
        preConfirm: (value) => {
            if (value) {
                if (currentTabLang.value == 1) {
                    customFieldsList.value[i].name = value
                } else {
                    customFieldsList.value[i].name_en = value
                }

                emits('update:customFieldsList', customFieldsList.value)
            }
        },
        allowOutsideClick: false,
    }).then((text) => {
        console.log(text);
    });
}

const changeUnit = () => {
    emits('update:customFieldsList', customFieldsList.value)
}

const changeName = () => {
    emits('update:customFieldsList', customFieldsList.value)
}
const handlerSwitch = () => {
    // console.log(customFieldsList.value);
    emits('update:customFieldsList', customFieldsList.value)
}

// watch(customFieldsList, (val) => {
//     console.log(val);
// }, { deep: true })

</script>
<template>
    <template v-for="(item, index) in customFieldsList" :key="index">
        <b-card v-show="route.query.type != 'view' || (route.query.type == 'view' && item.isShow)">
            <div class="row gy-3 w-100">
                <div class="d-flex justify-content-between align-items-center  pb-2"
                    style="font-weight: bold;border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                    <div>
                        <label class="form-label" v-if="item.showName">
                            <span>{{ currentTabLang == 1 ? item.name : item.name_en }}</span>
                            <i v-if="route.query.type != 'view'" class="ri-pencil-fill cursor-pointer"
                                @click.stop="editFields(index)"></i>
                        </label>
                        <template v-else>
                            <input v-show="currentTabLang == 1" @change="changeName"
                                :disabled="route.query.type == 'view'" type="text" class="form-control"
                                v-model="item.name" style="min-width: 300px;"
                                :placeholder="getLangValue('product-template.text')"
                                :class="[(isCheckForm && !item.name) && 'is-invalid']" />
                            <input v-show="currentTabLang == 2" @change="changeName"
                                :disabled="route.query.type == 'view'" type="text" class="form-control"
                                v-model="item.name_en" style="min-width: 300px;"
                                :placeholder="getLangValue('product-template.text')"
                                :class="[(isCheckForm && !item.name_en) && 'is-invalid']" />
                        </template>
                    </div>
                    <div style="width: 135px;" class="d-flex align-items-center justify-content-between"
                        v-if="route.query.type != 'view'">
                        <!-- <button :disabled="route.query.type == 'view'"  type="button" class="btn btn-success me-3" @click="handler('copy', index, item)"
                        v-if="!item.hideCopy">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        {{ getLangValue("base.copy") }}
                    </button>
                    <button :disabled="route.query.type == 'view'"  v-show="item.showDelete" type="button" class="btn btn-success me-3" style="background-color: #F06548;border:unset"
                        @click="handler('delete', index)">
                        <i class="ri-delete-bin-5-fill me-1 align-bottom"></i>
                        {{ getLangValue("base.delete") }}
                    </button> -->
                        <div class="form-check form-switch form-switch-success">
                            <input class="form-check-input" v-model="item.isShow" @change="handlerSwitch"
                                type="checkbox" role="switch" id="SwitchCheck3" checked>
                        </div>
                        <img v-if="!item.hideCopy" class="cursor-pointer" :src="copySvg"
                            @click="handler('copy', index, item)" style="width: 24px;" />
                        <i @click="handler('delete', index)" style="color:#ED5E5E"
                            v-show="item.showDelete && route.query.type != 'view'"
                            class=" cursor-pointer ri-delete-bin-5-fill me-1 align-bottom"></i>
                    </div>
                </div>
                <!-- 字段部分 -->
                <div class="row  d-flex justify-content-start">
                    <!-- 新增字段部分 -->
                    <div class="col-4 mt-2" v-for="(field, index_field) in item.fieldsList" :key="index_field">
                        <label class="form-label">
                            <span class="text-danger"></span>
                            <span>{{ currentTabLang == 1 ? field.name : field.name_en }}</span>
                            <i v-if="route.query.type != 'view'" class="ri-pencil-fill cursor-pointer"
                                @click="editField(index, index_field)"></i>
                        </label>
                        <div class="d-flex align-items-center">
                            <div style="display: inline; flex:1">
                                <div class="input-group" style="display: flex; " v-if="field.type == 'select'">
                                    <el-select v-model="field.value" placeholder=" " size="large"
                                        style="width: 100%; flex:1" clearable filterable allow-create disabled>
                                        <el-option v-for="item1 in field.list" :key="item1" :label="item1"
                                            :value="item1" />
                                    </el-select>
                                    <div class="input-group-text"> <input style="max-width:20px; display: inline;"
                                            class="form-check-input mt-0" type="checkbox"
                                            :disabled="route.query.type == 'view'" v-model="field.required"
                                            aria-label="Checkbox for following text input"></div>
                                </div>
                                <div class="input-group" style="display: flex;" v-else>
                                    <input type="text" class="form-control" disabled style="flex: 1;">
                                    <!-- <div class="input-group-text" style="max-width:120px; display: inline;"> -->
                                    <input style="flex: 1;" :disabled="route.query.type == 'view'" v-model="field.unit"
                                        class="form-control" @change="changeUnit" />
                                    <!-- </div> -->
                                    <div class="input-group-text"> <input style="max-width:20px; display: inline;"
                                            class="form-check-input mt-0" type="checkbox"
                                            :disabled="route.query.type == 'view'" v-model="field.required"
                                            aria-label="Checkbox for following text input"></div>
                                </div>

                            </div>
                            <i v-if="route.query.type !== 'view'" class="fs-16 ri-delete-bin-5-fill cursor-pointer"
                                style="color: #F06548; margin-left: 4px;" @click="deleteField(index, index_field)"></i>
                        </div>
                    </div>
                </div>
                <div style="text-align: center;">
                    <button :disabled="route.query.type == 'view'" type="button" class="btn btn-success me-3"
                        @click="addField(index)" style="min-width: 120px;">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        {{ currentTabLang==1? getLangValueByKey("product-template.addField"): getLangValueByKey("product-template.addField", 'en') }}
                    </button>
                </div>
                <!-- 上传框 -->
                <div style="pointer-events: none;" v-if="item.showUpload">
                    <DropZone1 :title="currentTabLang==1? getLangValueByKey('upload.title'):getLangValueByKey('upload.title', 'en') " :accept="'.png,.jpeg,.jpg,'" @drop.prevent="drop"
                        @change.prevent="selectedFile('2d')" style="min-height: 220px"
                        :info="item.info ? item.info : (currentTabLang==1? getLangValueByKey('upload.limit'): getLangValueByKey('upload.limit', 'en')) + '200M'" :currentTab="currentTabLang" />
                </div>
                <!-- 表格信息 -->
                <customTableCom :customTableList="item.tabList" v-if="item.showTable" />
            </div>
        </b-card>
    </template>
</template>
<style></style>